'use client';
import styled from 'styled-components';

const TitleContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.whiteSmoke};
  padding: 10px 15px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.gray87};
`;

export default TitleContainer;
